export default  {
  '展位号':'展位号',
  '商品信息':'商品信息',
  '规格':'规格',
  '单价':'单价',
  '数量':'数量',
  '小计':'小计',
  '操作':'操作',
  '描述':'描述',
  '暂无描述':'暂无描述',
  '暂无规格':'暂无规格',
  '含押金':'含押金',
  '删除':'删除',
  '费用合计':'费用合计',
  '展位费用项':'展位费用项',
  '已选择':'已选择',
  '个展位':'个展位',
  '展位':'展位',
  '首页':'首页',
  '租赁商品列表':'租赁商品列表',
  '租赁清单':'租赁清单',
  '结算':'结算',
  '返回':'返回',
  '租赁服务':'租赁服务'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/SettlementList.js